import { useCallback, useEffect } from 'react';
import { storeListener } from '~/firebase/listeners/store';

import storeInfoAtom from '~/recoil/atom/storeInfo';

import { useSetRecoilState } from 'recoil';

import { Store } from '~/types/store/store';
import { SnapshotFn } from '~/firebase/listeners/type';

export default function useStore(storeId: string) {
  const setStoreInfo = useSetRecoilState(storeInfoAtom);

  const handleStoreSnapshot = useCallback<SnapshotFn>(
    (doc) => {
      const data = doc.data() as Store | undefined;
      if (!doc.exists() || !data) {
        return;
      }

      setStoreInfo({
        id: doc.id,
        name: data.name,
        image: data.image,
        logo: data.logo,
        description: data.description,
        operatingTime: data.operatingTime,
        banners: data.banners,
        location: data.location,
        preOrderSetting: data.preOrderSetting,
        officialHoliday: data.officialHoliday.map((timestamp) => timestamp.toDate())
      });
    },
    [setStoreInfo],
  );

  useEffect(() => {
    if (storeId) {
      const unlisten = storeListener(storeId, handleStoreSnapshot);
      return () => {
        unlisten();
      };
    }
  }, [storeId]);
}
